export interface ChatHistoryItem {
  id: string;
  title: string;
}

interface ChatHistorySectionProps {
  history: ChatHistoryItem[];
  onSelect: (id: string) => void;
}

export function ChatHistorySection({ history, onSelect }: ChatHistorySectionProps) {
  return (
    <section className="sidebar__section">
      <header className="sidebar__section-header">
        <span className="sidebar__section-label">Chat history</span>
      </header>

      {history.length === 0 ? (
        <section className="sidebar__empty-state">
          <div className="sidebar__empty-title-row">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M17.044 10.744a7.046 7.046 0 0 1-3.503 5.391c-3.388 1.956-7.72.795-9.676-2.593l-.208-.36M2.955 9.256a7.046 7.046 0 0 1 3.503-5.39c3.388-1.957 7.72-.796 9.676 2.592l.208.36M2.911 15.055l.61-2.276 2.277.609M14.202 6.612l2.277.61.61-2.277M10 6.25V10l2.083 1.25"
                stroke="#7C7C67"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="sidebar__empty-title">No chats yet</span>
          </div>
          <p className="sidebar__empty-desc">Ask your first question to get started.</p>
        </section>
      ) : (
        <ul className="sidebar__list">
          {history.map((item) => (
            <li key={item.id}>
              <button type="button" className="sidebar__history-item" onClick={() => onSelect(item.id)}>
                {item.title}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
